import React from "react";
import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import { Button } from "ui/button";
import { AgentsVideo } from "./agents-video";

const GRADIENT_BG = "linear-gradient(to bottom, #E3FCEE -29.01%, #CCF0F9 51.63%, #CCF0F9 153.47%)";

export function AgentsVideoCard() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex
      direction={{ base: "column-reverse", lg: "row" }}
      gap="big"
      borderRadius="small"
      overflow="hidden"
      bg={GRADIENT_BG}
      pl={{ base: "smaller", lg: "biggest" }}
      pr={{ base: "smaller", lg: "big" }}
      pt={{ base: "smaller", lg: "big" }}
      pb={{ base: "bigger", lg: "big" }}
    >
      <Flex align="center">
        <Flex
          w="100%"
          flexDir="column"
          align={{ base: "center", md: "start" }}
          textAlign={{ base: "center", md: "start" }}
          gap="big"
        >
          <Text
            as="h3"
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight="bold"
            lineHeight={{ base: 1.3, md: 1.2 }}
            whiteSpace="pre-wrap"
          >
            Watch a quick demo with our founders
          </Text>

          <Button hasRightChevron variant="darkBlue" onClick={onOpen}>
            Watch video
          </Button>
        </Flex>
      </Flex>

      <Flex justifyContent="center" alignItems="center" pos="relative" w={{ base: "100%", lg: "80%" }}>
        <AgentsVideo
          hasPlayButton={false}
          borderRadius={{ base: "smaller", md: "smaller" }}
          mt={0}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Flex>
    </Flex>
  );
}
